var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheChariot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 437.6 272.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 214.45,
    y1: 188.09,
    x2: 362.64,
    y2: 23.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 67.96,
    y1: 23.98,
    x2: 214.45,
    y2: 188.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.11,
    y1: 248.79,
    x2: 214.45,
    y2: 188.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 413.62,
    y1: 248.79,
    x2: 214.45,
    y2: 188.09
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "392.34 256.66 405.74 245.17 405.74 227.51 417.24 240.92 434.89 240.92 421.49 252.41 421.49 270.07 410 256.66 392.34 256.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.31 267.52 12.59 250.39 2.38 235.99 19.51 240.27 33.91 230.06 29.63 247.19 39.84 261.59 22.71 257.31 8.31 267.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "55.16 42.71 59.44 25.58 49.22 11.18 66.35 15.46 80.76 5.25 76.47 22.38 86.69 36.78 69.56 32.5 55.16 42.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "341.36 31.85 354.77 20.36 354.77 2.7 366.26 16.11 383.92 16.11 370.51 27.6 370.51 45.26 359.02 31.85 341.36 31.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "195.73 197.61 207.78 187.28 197.84 174.9 212.81 180.17 218.56 165.38 221.49 180.98 237.17 178.56 225.13 188.89 235.06 201.27 220.09 196 214.34 210.79 211.42 195.19 195.73 197.61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheChariot);
export default __webpack_public_path__ + "static/media/TheChariot.53a448970867994c80a1bef6f0868112.svg";
export { ForwardRef as ReactComponent };